/* eslint "import/no-mutable-exports": "off" */
const eeTypes = [
  {
    type: 'HOME_LOAN',
    title: 'loans.home_loan',
    fields: ['monthlyPayment'],
    intl: true,
  },
  {
    type: 'CREDIT_CARD',
    title: 'loans.credit_card',
    fields: [],
    intl: true,
  },
  {
    type: 'LEASING_HIRE_PURCHASE',
    title: 'loans.leasing_hire_purchase_c24',
    fields: ['monthlyPayment'],
    intl: true,
    tooltipId: 'loans-leasing',
    tooltipDesc: 'tooltip.loans.leasing_hire_purchase',
  },
  {
    type: 'GUARANTEE_SURETY',
    title: 'loans.guarantee_surety',
    fields: ['monthlyPayment'],
    intl: true,
  },
  {
    type: 'OTHER',
    title: 'loans.other_c24',
    fields: ['monthlyPayment'],
    intl: true,
    tooltipId: 'loans-other',
    tooltipDesc: 'tooltip.loans.other',
  },
];

const fiTypes = [
  {
    type: 'HOUSE',
    title: 'loans.house',
    intl: true,
  },
  {
    type: 'CREDIT_CARD',
    title: 'loans.credit_card',
    intl: true,
  },
  {
    type: 'STUDY',
    title: 'loans.study',
    intl: true,
  },
  {
    type: 'FAST',
    title: 'loans.fast',
    intl: true,
  },
  {
    type: 'OTHER',
    title: 'loans.other',
    intl: true,
  },
];

const mxTypes = [
  {
    type: 'HOME_LOAN',
    title: 'loans.mortgage',
    intl: true,
  },
  {
    type: 'CREDIT_CARD',
    title: 'loans.credit_card',
    intl: true,
  },
];

let data = [];

switch (COUNTRY) {
  case 'FI':
    data = data.concat(fiTypes);
    break;
  case 'MX':
    data = data.concat(mxTypes);
    break;
  default:
    data = data.concat(eeTypes);
}

export default data;
